export default {
  bind(el) {
    el.keyPressEvent = function (event) {
      const isNumeric =
        event.keyCode === 8 || (event.charCode >= 48 && event.charCode <= 57)
      if (!isNumeric) {
        event.preventDefault()
      }
    }
    el.addEventListener('keypress', el.keyPressEvent)
  },
  // bind(el) {
  //   el.addEventListener('keyup', () => {
  //     const regex = /^[0-9]*$/
  //     if (!regex.test(el.value)) {
  //       el.value = el.value.slice(0, -1)
  //     }
  //   })
  // },

  unbind(el) {
    el.removeEventListener('keypress', el.keyPressEvent)
  }
}
